import { App } from "./core/App.js";
// Importing the PWA module here registers the beforeinstallprompt listener
// immediately at module-eval time, before window.onload, so we don't miss
// the event when the browser fires it early.
import { registerServiceWorker, persistStorage } from "./data/pwa.js";

window.onload = function()
{
    const container = document.getElementById( 'app' );

    // Prevent LittleJS document-level touch handlers from calling
    // preventDefault(), which blocks click synthesis on mobile.
    container.addEventListener( 'touchstart', e => e.stopPropagation() );
    container.addEventListener( 'touchend',   e => e.stopPropagation() );

    const app = new App( container );
    app.run();

    registerServiceWorker();
    persistStorage();
};
